export default {
  returnFloat(value) {
    const num = Math.round(parseFloat(value) * 100) / 100
    const s = num.toString().split('.')
    if (s.length === 1) {
      value = num.toString() + '.00'
      return value
    }
    if (s.length > 1) {
      if (s[1].length < 2) {
        value = num.toString() + '0'
      }
      return value
    }
  },
  /**
   * 除法
   * @param {number} dividend 除数
   * @param {number} divsisor 被除数
   * @param {number} precision 返回值会再乘这个数
   * @return {number}
   */
  divider(divsisor, dividend, precision) {
    if (divsisor && dividend) {
      var t1 = 0,
        t2 = 0,
        r1,
        r2;
      try {
        t1 = divsisor.toString().split(".")[1].length;
      } catch (e) {}
      try {
        t2 = dividend.toString().split(".")[1].length;
      } catch (e) {}
      r1 = Number(divsisor.toString().replace(".", ""));
      r2 = Number(dividend.toString().replace(".", ""));
      return this.multiple(
          ((r1 / r2) * Math.pow(10, t2 - t1)).toFixed(5),
          precision
      );
    } else {
      return 0;
    }
  },
  /**
   * 乘法
   * @param value1
   * @param value2
   * @returns {number}
   */
  multiple(value1, value2) {
    var m = 0,
        s1 = value1.toString(),
        s2 = value2.toString();
    try {
      m += s1.split(".")[1].length;
    } catch (e) {
    }
    try {
      m += s2.split(".")[1].length;
    } catch (e) {
    }
    return (
        (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
        Math.pow(10, m)
    );
  },
  /**
   * 加法
   * @param value1
   * @param value2
   * @returns {number}
   */
  sum(value1, value2) {
    const number = Number(value1);
    const number1 = Number(value2);
    if (!Number.isNaN(number) && !Number.isNaN(number1)) {
      return number + number1;
    }
    return 0;
  },
  /**
   * 减法
   * @param value1 被减数
   * @param value2 减数
   * @return {number} 差
   */
  subtract(value1, value2) {
    const number = Number(value1);
    const number1 = Number(value2);
    if (!Number.isNaN(number) && !Number.isNaN(number1)) {
      return number - number1;
    }
    return 0;
  },
  //排序
  sort(array, key, direction) {
    return array.sort(function (a, b) {
      const number = Number(a[key]);
      const number1 = Number(b[key]);

      if (direction == 'ascending') {
        if (Number.isFinite(number) && Number.isFinite(number1)) {

          //是数字
          return ((number < number1) ? -1 : (number > number1) ? 1 : 0);
        } else {

          return ((a[key] < b[key]) ? -1 : (a[key] > b[key]) ? 1 : 0);
        }
      } else {
        if (Number.isFinite(number) && Number.isFinite(number1)) {

          //是数字
          return ((number > number1) ? -1 : (number < number1) ? 1 : 0);
        } else {

          return ((a[key] > b[key]) ? -1 : (a[key] < b[key]) ? 1 : 0);
        }
      }
    })
  },
  flexColumnWidth(str) {
    let flexWidth = 0
    for (const char of str) {
      if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
        flexWidth += 8
      } else if (char >= '\u4e00' && char <= '\u9fa5') {
        flexWidth += 12
      } else {
        flexWidth += 8
      }
    }
    return flexWidth + 30 + 'px'
  },
  //节流
  throttle(callback, wait=200) {
    let start = 0
    return function (e) {
      const now = Date.now()
      if (now - start >= wait) {
        // callback(e)
        callback.call(this, e)
        start = now
      }
    }
  },

  // 防抖
  debounce(callback, wait=200) {
    let timer = null
    return function (e) {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        callback(e)
        timer = null
      }, wait)
    }
  },

  /**
   * 
   * @param {*} obj 需要处理的对象
   * @param {likeLeft,likeRight,likeBoth} funcName 有值的时候，对应的处理方法
   * @returns {Object}
   */
  clearNull(obj,funcName) {
    let result = {}
    for (const key in obj) {
      if (obj[key] === null || obj[key] === undefined || obj[key] === "" || (obj[key] instanceof Array && obj[key].length === 0)) {
        // delete obj[key]
      }else{
        if(funcName){
          this[funcName](result,key,obj[key])
        }else{
          result[key] = obj[key]
        }
      }
    }
    return result
  },

  likeLeft(obj, key, value) {
    return obj["like_" + key] = "%" + value;
  },
  likeRight(obj, key, value) {
    return obj["like_" + key] = value + "%";
  },
  likeBoth(obj, key, value) {
    return obj["like_" + key] = "%" + value + "%";
  },
  halfUp(obj, precision) {
    return this.multiple(obj.toFixed(precision), 1)
  },

  /**
   * 是空
   * @param value
   * @returns {boolean}
   */
  isBlank(value) {
    if (value === null || value === undefined || value === "" || (value instanceof Array && value.length <= 0)) {
      return true;
    }
    return false;
  },

  // 参数为null情况
  nullValue: function (v) {
    if (this.isBlank(v)) {
      return (v = "无");
    } else {
      return v;
    }
  },
}